import ListItem from 'components/ListItem';
import Price from 'components/Price';
import type { Option } from 'models/api';
import { slugify } from 'utils/string';

interface Props {
	onSizeClick: (sizeOption: Option) => void;
	sizes: Option[] | undefined;
}

export default function SizeView({ onSizeClick, sizes }: Props) {
	return (
		<ul className="flex flex-col gap-2">
			{sizes?.map((size, i) => (
				<ListItem
					onClick={() => onSizeClick(size)}
					as="li"
					title={size.text || ''}
					key={size.key}
					className="rounded-xs border border-strong p-4"
					endContent={
						size.price ? <Price price={size.price} size="xs" /> : null
					}
					data-cy={`print-size-${size.text ? slugify(size.text) : i + 1}`}
				/>
			))}
		</ul>
	);
}
SizeView.displayName = 'ProductPrintPopover_SizeView';
